// extracted by mini-css-extract-plugin
export default {"ellipsis":"GoldcastText_ellipsis_LdSwr"};